import ResetPasswordDialog from "./ResetPasswordDialog";

export default ResetPasswordDialog;